    import React, { useState } from 'react';
    import ImageGallery from 'react-image-gallery';
    import './CardNewsGallery.scss';
    import { getImageUrl, getThumbnailUrl } from '../../utils/imageAssets';

    const CardNewsGallery = ({ images, title, onClose }) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isFullscreen, setIsFullscreen] = useState(false);

    const galleryImages = images?.map((src, index) => ({
        original: getImageUrl(src),
        thumbnail: getThumbnailUrl(src),
        originalAlt: `${title} ${index + 1}`,
        thumbnailAlt: `${title} ${index + 1}`
    })) || [];


    const handleScreenChange = (isFullScreen) => {
        setIsFullscreen(isFullScreen);
        console.log(isFullScreen);
    };

  //===================================================================

    return (
        <div className="cardnews-gallery-modal">
        <div className="cardnews-gallery-content">
            <button className="close-btn" onClick={onClose} aria-label="닫기">
            ✕
            </button>
            <div className="gallery-wrapper">
            <ImageGallery 
                items={galleryImages}
                lazyLoad={true}
                showPlayButton={true}
                showFullscreenButton={true}
                autoPlay={false}
                onScreenChange={handleScreenChange}
                showThumbnails={false} 
            />
            </div>
            <div className="gallery-meta">
            <h3 className="gallery-title">{title}</h3>
            <div className="slide-counter">
                {currentIndex + 1} / {galleryImages.length}
            </div>
            </div>
        </div>
        </div>
    );
    };

    export default CardNewsGallery;
